<div class="login-container">
  <app-header-title
    [title]="'Redefinir Senha'"
    [link]="'/auth'"
  ></app-header-title>

  <form [formGroup]="resetForm" class="login-form">
    <div class="form-group">
      <label for="newPassword">Nova Senha</label>
      <input
        id="newPassword"
        type="password"
        formControlName="newPassword"
        class="form-control"
      />
      @if(resetForm.get('newPassword')?.invalid
      &&resetForm.get('newPassword')?.touched){
      <small class="error"> Senha é obrigatória </small>
      }
    </div>
    <div class="form-group">
      <label for="confirmPassword">Confirmar Senha</label>
      <input
        id="confirmPassword"
        type="password"
        formControlName="confirmPassword"
        class="form-control"
      />
      @if(resetForm.get('confirmPassword')?.invalid
      &&resetForm.get('confirmPassword')?.touched){
      <small class="error"> Confirmar Senha é obrigatória </small>
      }
    </div>
  </form>
  <div class="login-footer">
    <button
      (click)="onSubmit()"
      type="submit"
      [disabled]="resetForm.invalid"
      class="btn btn-primary"
    >
      Redefinir
    </button>
  </div>
</div>
